import Index from 'src/pages/CollectiveBookings/Index.vue'

const auth = { requiresAuth: true }

export default [
  {
    path: '/collective-bookings',
    name: 'Sammelbuchungen',
    component: Index,
    meta: auth
  }
]
